export default {"src":"/_next/static/media/lightbulb.1b471948.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};